<bevvi-bot-chat-card
  [type]="type.ORDER_SUMMARY"
  [orderItems]="payload().items"
  [totalAmount]="payload().subtotal"
  [showActions]="true"
  [primaryButtonText]="payload().primaryAction?.label ?? ''"
  [secondaryButtonText]="payload().secondaryAction?.label || ''"
  [disabled]="disabled()"
  (submitClick)="onPrimaryClick()"
  (secondaryClick)="onSecondaryClick()"
/>
